import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Theme, userConfigStore } from "@/store/user-config-store";
import { useTranslation } from "react-i18next";
import { ACCENT_SCHEMES, DARK_BASE_SCHEMES, LIGHT_BASE_SCHEMES } from "../_constants/themes";
import { AccentSchemePicker } from "./accent-scheme-picker";
import { BaseSchemePicker } from "./base-scheme-picker";

export function AppearanceSection() {
  const { t } = useTranslation("user-settings");
  const theme = userConfigStore((state) => state.theme);
  const lightAccentScheme = userConfigStore((state) => state.lightAccentScheme);
  const darkAccentScheme = userConfigStore((state) => state.darkAccentScheme);
  const lightBaseScheme = userConfigStore((state) => state.lightBaseScheme);
  const darkBaseScheme = userConfigStore((state) => state.darkBaseScheme);
  const setTheme = userConfigStore((state) => state.setTheme);
  const setLightAccentScheme = userConfigStore((state) => state.setLightAccentScheme);
  const setDarkAccentScheme = userConfigStore((state) => state.setDarkAccentScheme);
  const setLightBaseScheme = userConfigStore((state) => state.setLightBaseScheme);
  const setDarkBaseScheme = userConfigStore((state) => state.setDarkBaseScheme);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Appearance")}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between gap-4">
          <Label className="text-sm font-medium">{t("ThemeMode")}</Label>
          <Select value={theme} onValueChange={(value) => setTheme(value as Theme)}>
            <SelectTrigger className="w-40">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={Theme.System}>{t("SystemMode")}</SelectItem>
              <SelectItem value={Theme.Light}>{t("LightMode")}</SelectItem>
              <SelectItem value={Theme.Dark}>{t("DarkMode")}</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label className="mb-4 block text-sm font-medium">{t("LightTheme")}</Label>
          <div className="space-y-4">
            <BaseSchemePicker
              label={t("BaseScheme")}
              schemes={LIGHT_BASE_SCHEMES}
              selectedScheme={lightBaseScheme}
              onSelect={setLightBaseScheme}
            />
            <AccentSchemePicker
              label={t("AccentScheme")}
              schemes={ACCENT_SCHEMES}
              selectedScheme={lightAccentScheme}
              onSelect={setLightAccentScheme}
              mode={Theme.Light}
            />
          </div>
        </div>

        <div>
          <Label className="mb-4 block text-sm font-medium">{t("DarkTheme")}</Label>
          <div className="space-y-4">
            <BaseSchemePicker
              label={t("BaseScheme")}
              schemes={DARK_BASE_SCHEMES}
              selectedScheme={darkBaseScheme}
              onSelect={setDarkBaseScheme}
            />
            <AccentSchemePicker
              label={t("AccentScheme")}
              schemes={ACCENT_SCHEMES}
              selectedScheme={darkAccentScheme}
              onSelect={setDarkAccentScheme}
              mode={Theme.Dark}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
